<template>
    <div class="dx-field">
        <div class="dx-field-label hist-date-label">Как менял</div>
        <div class="dx-field-value">
            <DxSelectBox
                v-model:value="conditions.oper"
                :data-source="operations"
                value-expr="operation"
                display-expr="label"                
                :accept-custom-value="false"
                :show-clear-button="true"
                @valueChanged="setOperation"
            />
        </div>
    </div>
</template>

<script setup>
import { onMounted, inject } from 'vue';

import { DxSelectBox } from 'devextreme-vue/select-box';

const operations = [
    { operation: 'I', label: 'Добавлял' },
    { operation: 'U', label: 'Менял' },
    { operation: 'D', label: 'Удалял' },
];

const conditions = inject('conditions');

onMounted(() => {

});

const setOperation = async () => {
    console.log('histroy-operation.setOperation', conditions.value.oper);
};
</script>

<style scoped>
.hist-date-label {
    margin-bottom: 3px;
}
</style>
